var _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "follgdsa0a",
    width: 7,
    height: 4,
    x: 32,
    y: 45,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32.55 45.58h6.154v2.772H32.55v-2.773z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#follgdsa0a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M37.317 45.58h-3.38c-.765 0-1.386.62-1.386 1.385s.62 1.386 1.386 1.386h3.38c.766 0 1.386-.62 1.386-1.386 0-.765-.62-1.386-1.386-1.386",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "bktwik4evb",
    width: 21,
    height: 35,
    x: 12,
    y: 14,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.948 14.773H32.24v33.578H12.948V14.773z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bktwik4evb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M28.96 45.579h-1.748V28.632l4.622-4.622c.542-.54.542-1.419 0-1.96-.542-.542-1.419-.542-1.96 0l-2.662 2.661V16.16c0-.765-.62-1.387-1.386-1.387-.766 0-1.386.622-1.386 1.387v2.578l-1.004-1.004c-.542-.54-1.42-.54-1.96 0-.542.542-.542 1.42 0 1.96l2.8 2.8c.05.051.107.093.164.134v22.95H14.334c-.765 0-1.386.622-1.386 1.387s.621 1.386 1.386 1.386H28.96c.765 0 1.386-.62 1.386-1.386 0-.765-.621-1.386-1.386-1.386",
    clipRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "p1fbr2l12c",
    width: 15,
    height: 13,
    x: 7,
    y: 26,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7 26.815h14.214v11.33H7v-11.33z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#p1fbr2l12c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M19.828 38.145c.765 0 1.386-.622 1.386-1.387s-.62-1.386-1.386-1.386h-2.885c-3.954 0-7.17-3.217-7.17-7.17 0-.766-.62-1.387-1.387-1.387-.765 0-1.386.621-1.386 1.386 0 5.483 4.46 9.944 9.943 9.944h2.885z",
    clipRule: "evenodd"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "aob335zskd",
    width: 34,
    height: 38,
    x: 11,
    y: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.6 2H44v36.145H11.6V2z",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aob335zskd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M37.536 18.887c.847-1.112 1.33-2.49 1.33-3.95 0-3.594-2.925-6.52-6.52-6.52-.11 0-.218.003-.326.008C31.97 4.874 29.064 2 25.5 2c-3.564 0-6.468 2.874-6.519 6.425-.109-.005-.218-.007-.327-.007-3.595 0-6.52 2.925-6.52 6.52 0 1.46.486 2.84 1.333 3.953-.38.143-.755.31-1.121.5-.679.355-.942 1.192-.588 1.87.354.68 1.192.943 1.87.59.951-.497 1.98-.768 3.059-.806.648-.023 1.195-.494 1.313-1.131.119-.639-.22-1.274-.818-1.53-1.382-.59-2.275-1.944-2.275-3.446 0-2.067 1.68-3.748 3.747-3.748.507 0 .998.1 1.46.296.502.214 1.088.112 1.49-.263.4-.375.542-.951.361-1.469-.14-.405-.212-.82-.212-1.234 0-2.067 1.68-3.748 3.747-3.748s3.748 1.681 3.748 3.748c0 .413-.072.829-.213 1.234-.18.518-.038 1.094.362 1.469.401.375.988.478 1.49.263.461-.197.952-.296 1.46-.296 2.065 0 3.747 1.681 3.747 3.748 0 1.502-.894 2.856-2.276 3.447-.597.255-.937.891-.817 1.529.119.638.664 1.108 1.313 1.13 3.877.138 6.914 3.282 6.914 7.157 0 3.954-3.216 7.171-7.171 7.171h-3.199c-.765 0-1.386.62-1.386 1.386 0 .766.621 1.387 1.386 1.387h3.199C39.54 38.145 44 33.684 44 28.2c0-4.277-2.666-7.912-6.464-9.314",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbol);
export default __webpack_public_path__ + "static/media/arbol.f16ee92c70e0a768ac0b914ae71df052.svg";
export { ForwardRef as ReactComponent };